import { render, staticRenderFns } from "./Form19StyleOfProceeding.vue?vue&type=template&id=a6355952&scoped=true"
import script from "./Form19StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form19StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form19StyleOfProceeding.vue?vue&type=style&index=0&id=a6355952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6355952",
  null
  
)

export default component.exports